import React, { useEffect, useState, useRef } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import i18next from 'i18next';
import Button from 'react-bootstrap-button-loader';
import styles from '../../../styles/profile.module.css';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import AlertAlgo from '../../controls/AlertSnack'

import FormControl from '@material-ui/core/FormControl';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';

import { getPendingProfileList, deletePendingProfile } from '../../../actions/myFile/profile';
import { toPhone, toPostalCode } from '../../../utils';
import * as StatusCode from '../../../scripts/StatusCode';
import { withNamespaces } from 'react-i18next';
import { formatDate } from '../../../utils';

const useStyles = makeStyles((theme) => ({
    firstCell: {
        width: '350px',
        '@media (max-width: 600px)': {
            width: "160px"
        },
        textAlign: 'left',
        float: 'left'
    },
    secondCell: {
        width: '350px',
        '@media (max-width: 600px)': {
            width: "65px"
        },
        float: 'left'
    },
    rootProfile: {
        overflow: 'auto',
        padding: '15px'
    },
    appBar: {
        position: 'relative',
        backgroundColor: 'var(--color1) !important',
        color: 'var(--color2) !important'
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    divButtons: {
        textAlign: 'center',
        marginTop: '15px',
    },
    rootTable: {
        '& td': {
            fontSize: 16,
            '@media (max-width: 600px)': {
                fontSize: 11,
            }
        },
        '& td:first-child': {
            width: '30%',
            '@media (max-width: 600px)': {
                width: '45%'
            }
        },
    }
}));

const StyledFirstTableCell = withStyles((theme) => ({
    body: {
        fontSize: 16,
        fontWeight: 'bolder',
        '@media (max-width: 600px)': {
            fontSize: 11,
        }
    },
}))(TableCell);

const StyledSecondTableCell = withStyles((theme) => ({
    head: {
        color: '#000000!important',
        fontSize: 16,
        width: '75%',
        '@media (max-width: 600px)': {
            fontSize: 12,
            width: "75%"
        },
        fontWeight: 'bold'
    },
    body: {
        fontSize: 16,
        '@media (max-width: 600px)': {
            fontSize: 11,
        }
    },
}))(TableCell);

function ProfilePendingList(props) {
    const classes = useStyles();

    const [data, setData] = useState([]);
    const [isPending, setIsPending] = useState(props.isPending || false);
    const [openWarning, setOpenWarning] = useState(false);

    const alertRef = useRef(null);

    useEffect(() => {
        loadPendingProfileList();
        resize();
    }, []);

    useEffect(() => {
        if (props.isReload) {
            loadPendingProfileList();
        }
    }, [props.isReload]);

    const resize = () => {
        setTimeout(function () {
            const height = window.innerHeight;
            const titleBar = document.querySelector('#appBarTitle').clientHeight;
            const offSet = 50;

            const customHeight = height - titleBar - offSet;

            const element = document.querySelector('#divProfile');

            if (element !== undefined && element !== null) {
                element.style.height = `${customHeight}px`;
            }
        }, 0);
    }

    const loadPendingProfileList = () => {
        getPendingProfileList().then(response => {
            response.personalPhone = toPhone(response.personalPhone);
            response.personalCellphone = toPhone(response.personalCellphone);
            response.postalCode = toPostalCode(response.postalCode);

            setIsPending(true);

            setData(response);
        });
    }

    const handleEdit = () => {
        props.handleEdit();
    }

    const showMessageError = (message) => {
        alertRef.current.showMessageError(message);
    }

    const handleSupprimer = () => {
        const id = data.employeeChangeId;

        if (id > 0) {
            deletePendingProfile(id).then(response => {
                if (response != null && response.status == StatusCode.STATUS_OK) {
                    handleDelete();
                    return;
                }
                showMessageError(i18next.t('error:generic-error'));
            });
        } else {
            showMessageError(i18next.t('error:generic-error'));
        }
    }

    const handleWarning = (isContinue) => {
        setOpenWarning(false);

        if (isContinue == true) {
            handleSupprimer();
        }
    }

    const handleDelete = () => {
        props.handleDelete();
    }

    return (
        <div>
            <div id="divProfile" className={styles.detailProfil}>
                <TableContainer className={classes.rootTable} onClick={handleEdit}>
                    <Table className={classes.table} aria-label="spanning table">
                        <TableBody>
                            <TableRow>
                                <StyledFirstTableCell>{i18next.t('profile:address.form.effectiveDate')}</StyledFirstTableCell>
                                <StyledSecondTableCell>{formatDate(data.effectiveDate, 'date')}</StyledSecondTableCell>
                            </TableRow>
                            <TableRow>
                                <StyledFirstTableCell>{i18next.t('profile:list.street')}</StyledFirstTableCell>
                                <StyledSecondTableCell>{data.address1}</StyledSecondTableCell>
                            </TableRow>
                            {data.address2 && <TableRow>
                                <StyledFirstTableCell></StyledFirstTableCell>
                                <StyledSecondTableCell>{data.address2}</StyledSecondTableCell>
                            </TableRow>}
                            <TableRow>
                                <StyledFirstTableCell>{i18next.t('profile:list.city')}</StyledFirstTableCell>
                                <StyledSecondTableCell>{data.city}</StyledSecondTableCell>
                            </TableRow>
                            <TableRow>
                                <StyledFirstTableCell>{i18next.t('profile:list.province')}</StyledFirstTableCell>
                                <StyledSecondTableCell>{data.province}</StyledSecondTableCell>
                            </TableRow>
                            <TableRow>
                                <StyledFirstTableCell>{i18next.t('profile:list.postalCode')}</StyledFirstTableCell>
                                <StyledSecondTableCell>{data.postalCode}</StyledSecondTableCell>
                            </TableRow>
                            <TableRow>
                                <StyledFirstTableCell>{i18next.t('profile:list.personalPhone')}</StyledFirstTableCell>
                                <StyledSecondTableCell>{data.personalPhone}</StyledSecondTableCell>
                            </TableRow>
                            <TableRow>
                                <StyledFirstTableCell>{i18next.t('profile:list.personalCellphone')}</StyledFirstTableCell>
                                <StyledSecondTableCell>{data.personalCellphone}</StyledSecondTableCell>
                            </TableRow>
                            <TableRow>
                                <StyledFirstTableCell>{i18next.t('profile:list.personalEmail')}</StyledFirstTableCell>
                                <StyledSecondTableCell>{data.personalEmail}</StyledSecondTableCell>
                            </TableRow>
                            <TableRow>
                                <StyledFirstTableCell>{i18next.t('profile:address.form.comment')}</StyledFirstTableCell>
                                <StyledSecondTableCell>{data.comment}</StyledSecondTableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
            <FormControl fullWidth className="formDivButtons">
                <div style={{ padding: '0px 13px' }}>
                    <Button className="saveButton"  onClick={() => setOpenWarning(true)} variant="danger">
                        {i18next.t('buttons:delete')}
                    </Button>
                </div>
            </FormControl>
            <Dialog
                open={openWarning}
                onClose={() => alert('false')}
                aria-labelledby="draggable-dialog-title"
            >
                <DialogTitle id="draggable-dialog-title">
                    {i18next.t('profile:message.warning')}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {i18next.t('profile:address.message.confirmDelete')}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={() => handleWarning(true)} color="primary" className={styles.buttonYesNo} variant="success">
                        {i18next.t('buttons:yes')}
                    </Button>
                    <Button onClick={() => handleWarning(false)} color="primary" className={styles.buttonYesNo} variant="success">
                        {i18next.t('buttons:no')}
                    </Button>
                </DialogActions>
            </Dialog>
            <AlertAlgo ref={alertRef} />
        </div>
    );
}

export default withNamespaces(['Language', 'profile', 'buttons', 'error'], { wait: true })(ProfilePendingList);